import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const PasswordChangeForm_UpdateAuthenticatedUserAccount_Mutation =
  graphql(`
    mutation PasswordChangeForm_UpdateAuthenticatedUserAccount(
      $currentPassword: NonEmptyString!
      $newPassword: NonEmptyString!
    ) {
      updateAuthenticatedUserAccount(
        currentPassword: $currentPassword
        newPassword: $newPassword
      ) {
        _id
        mustChangePassword
      }
    }
  `);

export const usePasswordChangeMutation = () =>
  useGraphQLMutation(
    PasswordChangeForm_UpdateAuthenticatedUserAccount_Mutation,
  );
